(function () {
    'use strict';
    //todo: show protocols in agenda ('ShowInAgenda')
    var module = angular.module('uwAgenda.ringfoon');
    // protocol broadcaster
    module.factory('ProtocolBroadcastService', ['$rootScope', 'ProtocolBroadcast', 'SharedAgendaService', ProtocolBroadcastServiceFn]);

    function ProtocolBroadcastServiceFn($rootScope, ProtocolBroadcast, SharedAgendaService) {

        var service = {
            broadcast: broadcast
        };

        return service;

        // show defined protocol of current user -> broadcast to directive to open modal
        function broadcast(filter, appointmentTypeId) {

            // protocols are only visible for ringfoon users
            if (!$rootScope.isRingfoon) {
                return;
            } // if                        

            // find protocol by filter and optional appointmentTypeId
            function filtering(protocol) {
                // search by filter-protocol-flag or appointmentTypeId
                if (filter !== null) {
                    return protocol[filter];                    
                } // filter flags
                else if (appointmentTypeId !== null && appointmentTypeId > 0) {
                    return protocol.fK_AppointmentType === appointmentTypeId;
                } // else if

                return false;
            } //filtering

            // protocols available ?
            if (typeof SharedAgendaService.data.currentAgenda.owner.protocols !== 'undefined' && SharedAgendaService.data.currentAgenda.owner.protocols !== null && SharedAgendaService.data.currentAgenda.owner.protocols.length > 0) {
                var protocol = SharedAgendaService.data.currentAgenda.owner.protocols.filter(filtering)[0];
                // protocol to show ?
                if (typeof protocol !== 'undefined' && protocol !== null) {
                    $rootScope.$broadcast(ProtocolBroadcast.Show, protocol);
                } //if
            } // if
        } // broadcast


    }
})();